import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SiteHeader } from '@/components/layout/SiteHeader';
import { SiteFooter } from '@/components/layout/SiteFooter';
import { Reveal, fadeInUp } from '@/components/landing/motion';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col paper-archive">
      <SiteHeader />
      <main className="flex-1 mx-auto max-w-2xl px-5 sm:px-6 py-24 md:py-32 text-center">
        <Reveal variant={fadeInUp}>
        <div className="card-paper inline-flex flex-col items-center gap-3 px-10 py-12 mx-auto">
          <p className="num text-7xl font-semibold text-ink-200 tracking-tighter">404</p>
          <h1 className="mt-2 display serif-jp text-2xl font-semibold text-ink-900">
            {t('common.not_found_title', { defaultValue: 'Page not found.' })}
          </h1>
          <p className="text-ink-600 max-w-md text-pretty">
            {t('common.not_found_sub', { defaultValue: "The URL you followed doesn't lead anywhere — yet." })}
          </p>
          <Link to="/" className="btn-press mt-5 inline-flex items-center">
            {t('common.back_home', { defaultValue: 'Back to home' })}
          </Link>
        </div>
        </Reveal>
      </main>
      <SiteFooter />
    </div>
  );
}
